import { ACCOUNT_SETTINGS_ACTION_TYPE } from "@obg/ngx.common";

import { LOGIN_ACTION_TYPE } from "./login.action";

export const LOGIN_ROUTE = {
	forgotPassword: "forgot-password",
	resetPasswordByEmail: "reset-password-by-email",
	resetPasswordBySms: "reset-password-by-sms",
	resetPassword: "reset-password",
	resetPasswordTokenOnly: "reset-password-token-only",
	resetPasswordEmailToken: "reset-password-email-token",
};

export const LOGIN_MESSAGE_CONTEXT = {
	changePassword: ACCOUNT_SETTINGS_ACTION_TYPE.changePassword,
	resetPasswordWithToken: LOGIN_ACTION_TYPE.resetPasswordWithToken,
	resetPasswordByEmail: LOGIN_ACTION_TYPE.resetPasswordByEmail,
	resetPasswordBySms: LOGIN_ACTION_TYPE.resetPasswordBySms,
};
